import StatusCard from "./StatusCard";
import "./StatusDetails.css";

const StatusDetails = ({ data }) => {
  if (!data) return;
  return (
    <div className="stats-details">
      <StatusCard
        title="Total Items"
        // value="45"
        value={data?.totalSoldItems || 0}
        badge="+8.2%"
        subText=" from last month"
      />

      <StatusCard
        title="Revenue From Items"
        // value="₹45"
        value={data?.totalRevenue?.[0].totalRevenue}
        badge="+5.2%"
        subText=" from last month"
      />

      {/* <StatusCard
        title="Revenue From Items"
        value="₹45"
        badge="+8.2%"
        subText="+8.2% from last month"
      /> */}
    </div>
  );
};

export default StatusDetails;
